/**
 * @module $_GP.fn.slick
 * @example
	$_GP.fn.slick.slickSimple('#slick-element', {
		arrows: true,
		cssEase: 'ease',
		centerMode: false,
		dots: false,
		draggable: true,
	});
 * @returns {object} slicks objects
 * @property {object} slick.slickSimple
 * @property {object} slick.slickFull
 */
$_GP.fn.slick = (function() {
	/**
	 * Base slick with few defaults set
	 * @param {string} elm - base element
	 * @param {object} opt - slick options
	 * @returns {object} slick object
	 */
	const slickSimple = function(elm, opt) {
		elm = $(elm);
		opt = opt || {};
		if (!elm.length) return;

		const dataOpt = elm.data('slick') || {};

		const defaults = {
			infinite: true,
			speed: 300,
			slidesToShow: 1,
			slidesToScroll: 1
		};

		const options = $.extend({}, defaults, dataOpt, opt);

		return elm.slick(options);
	};

	/**
	 * Slick with a lot of defaults set
	 * @param {string} elm - base element
	 * @param {object} opt - slick options
	 * @returns {object} slick object
	 */
	const slickFull = function(elm, opt) {
		elm = $(elm);
		opt = opt || {};
		if (!elm.length) return;

		const dataOpt = elm.data('slick') || {};

		const defaults = {
			infinite: true,
			lazyLoad: 'ondemand',
			speed: 300,
			slidesToShow: 6,
			slidesToScroll: 1,
			autoplay: false,
			autoplaySpeed: 5000,
			responsive: [
				{
					breakpoint: 1200,
					settings: { slidesToShow: 5}
				},
				{
					breakpoint: 992,
					settings: { slidesToShow: 4}
				},
				{
					breakpoint: 768,
					settings: { slidesToShow: 3}
				},
				{
					breakpoint: 480,
					settings: { slidesToShow: 2}
				}
			]
		};

		const options = $.extend({}, defaults, dataOpt, opt);

		return elm.slick(options);
	};

	return {
		slickSimple: slickSimple,
		slickFull: slickFull
	};
}());
